<template>
  <div
    :key="message"
    v-tooltip="{
      placement: props.placement,
      title: message,
      template: props.customTemplate,
    }"
    style="opacity: 1; z-index: 0"
    v-if="!props.disabled"
  >
    <slot></slot>
  </div>
  <div v-else style="opacity: 1; z-index: 0">
    <slot></slot>
  </div>
</template>

<script setup>
import { useToolTipData } from "@/stores/tooltipData.js";
import { computed } from "vue";

const store = useToolTipData();

const props = defineProps({
  placement: {
    type: String,
    default: "top",
  },
  customTemplate: {
    type: String,
    default: "",
  },
  location: {
    type: String,
    required: false,
  },
  identifier: {
    type: String,
    required: false,
  },
  replaceValue: {
    type: Object,
    default: () => ({}),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  customMessage: {
    type: String,
    default: "",
  },
});

// TODO: Clean this up later
const message = computed(() => {
  if (props.customMessage) return props.customMessage;

  const defaultMessage =
    "🙈 Explanation still brewing, but stay tuned! Coming soon! 🚀🌟";

  const tooltip = store.tooltipData.find(
    (item) =>
      item.identifier === props.identifier && item.location === props.location
  );

  let updatedMessage = tooltip?.content || defaultMessage;

  if (updatedMessage !== defaultMessage && props.replaceValue) {
    const entries = Object.entries(props.replaceValue);
    if (entries.length > 0) {
      entries.forEach(([oldValue, newValue]) => {
        updatedMessage = updatedMessage.replaceAll(oldValue, newValue);
      });
    }
  }

  return updatedMessage;
});
</script>
